import { useFormInternalContext } from "../utils/formContext.js";
function useFormApi() {
  const { api } = useFormInternalContext();
  return api;
}
export {
  useFormApi
};
//# sourceMappingURL=useFormApi.js.map
